


//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// import created components  :
import Background from '../../components/background/Background.jsx'
import ProgressBar from '../../components/progressbar/ProgressBar.jsx'
import WallyBanner from '../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />
import ClientInfos from './ClientInfos.jsx'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getSelectedCreneaux, getFormules, getEleves, getFormulesEleves, getClient } from "../../store/selectors.js";


//MUI :
import Button from '@mui/material/Button';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';


//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function ClientInfosPage() { // full page as component imported in router


    const navigate = useNavigate();
    const dispatch = useDispatch();
    let selectedCreneaux = useSelector(getSelectedCreneaux);

    let theClient = useSelector(getClient);
    const lang = useSelector(getLang) //global state : language

    const [formValid, setFormValid] = useState(false);


    //// -- at first render :
    useEffect(() => {
        //security : redirect
        console.log(selectedCreneaux);
        if (selectedCreneaux.length === 0 || theClient.length === 0) {
            navigate("../calendar");
        }
    })
    //// -- 




    return (
        <div className="bg-relative">
            <Background ind={1} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner />

                    <div className="main-progress-bar">
                        <ProgressBar currentStep={4} total={5} />
                    </div>

                    <ClientInfos setFormValid={setFormValid} />




                    <div className="bottom-nav">
                        <Button
                            className="bottom-nav-prev"
                            onClick={_ => navigate("../calendar")}
                            variant="contained">
                            <SkipPreviousIcon />{translator("Précédent", lang, "BtPrevious")}
                        </Button>

                        <Button
                            className="bottom-nav-next"
                            disabled={!formValid}
                            onClick={_ => navigate("../confirmation")}
                            variant="contained">
                            {translator("Suivant", lang, "BtNext")} <SkipNextIcon />
                        </Button>
                    </div>

                </div>
            </main>
        </div>
    );
}

export default ClientInfosPage;